import { render, staticRenderFns } from "./landing-scalapay.vue?vue&type=template&id=0357714a&"
import script from "./landing-scalapay.vue?vue&type=script&lang=js&"
export * from "./landing-scalapay.vue?vue&type=script&lang=js&"
import style0 from "./landing-scalapay.vue?vue&type=style&index=0&id=0357714a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports